import _defineProperty from "@babel/runtime/helpers/defineProperty";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../constants/proptypes/AddonDiscoveryPropTypes";
import TextSearchWrapper from "../TextSearchWrapper";
import StandardTextSearchInner from "./StandardTextSearchInner";
export default class StandardTextSearch extends Component {
  render() {
    return /*#__PURE__*/React.createElement(TextSearchWrapper, {
      filters: this.props.filters,
      searchComponent: StandardTextSearchInner,
      perspective: this.props.perspective,
      stateChangeRequested: this.props.stateChangeRequested
    });
  }

}

_defineProperty(StandardTextSearch, "propTypes", {
  filters: CommonPropTypes.filters.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});